    import React, {useEffect, useState} from 'react';
    import axios from "axios";
    import {Link, useNavigate} from 'react-router-dom';
    import Select from 'react-select';
    import {useForm, Controller} from "react-hook-form";
    import PokemonCard from "../components/PokemonCard";
    import ReactDOM from "react-dom/client";
    import PokemonBattleCard from "../components/PokemonBattleCard";
    import Navbar from "../components/Navbar";


    const WinRatecalculator = () => {
        const [pokemane, setPokemane] = useState(null);
        const [selectedPokemon2,setSelectedPokemon2] = useState()
        const [selectedPokemon1,setSelectedPokemon1] = useState()
        const [selectedPokemonDmg1,setSelectedPokemonDMg1] = useState()
        const [selectedPokemonDgm2,setSelectedPokemonDmg2] = useState()
        const [names, setNames] = useState([]);
        const [winChnace ,setWinChnace] = useState()
        useEffect(() => {
            axios.get(`https://pokeapi.co/api/v2/pokemon?limit=100000&offset=0`)
                .then(res => setPokemane(res.data))
                .catch(err => console.error(err));
        }, []);
        useEffect(() => {
            if (pokemane?.results?.length > 0) {
                const options = pokemane.results.map(i => ({
                    value: i.name,
                    label: i.name
                }));

                setNames(options);
            }
        }, [pokemane]);


            const onSubmit = async (data) => {
                const res1 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${data.pokemon1.value}`);
                const res2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${data.pokemon2.value}`);
                setSelectedPokemon1(res1.data);
                setSelectedPokemon2(res2.data);
            };
        useEffect(() => {
            if (!(selectedPokemon1 && selectedPokemon2)) {
                return;
            }

            const fetchTypeData = async () => {
                try {
                    const poke1type = selectedPokemon1.types;
                    const poke2type = selectedPokemon2.types;

                    const typeUrls1 = poke1type.map(t => t.type.url);
                    const typeUrls2 = poke2type.map(t => t.type.url);

                    const res1 = await Promise.all(typeUrls1.map(url => axios.get(url)));
                    const res2 = await Promise.all(typeUrls2.map(url => axios.get(url)));
                    setSelectedPokemonDmg2(res2)
                    setSelectedPokemonDMg1(res1)
                } catch (error) {
                    console.error("Chyba při načítání typů:", error);
                }
            };

            fetchTypeData();
        }, [selectedPokemon1, selectedPokemon2]);
        useEffect(() => {
            if (!(selectedPokemonDmg1 && selectedPokemonDgm2)) {
                return;
            }

            const poke1Relations = selectedPokemonDmg1.map(res => ({
                type: res.data.name,
                damage_relations: res.data.damage_relations
            }));

            const poke2Relations = selectedPokemonDgm2.map(res => ({
                type: res.data.name,
                damage_relations: res.data.damage_relations
            }));

            //console.log("Vztahy pro Pokémon 1:", poke1Relations);
            //console.log("Vztahy pro Pokémon 2:", poke2Relations);

            let poke1atk = parseInt(selectedPokemon1.stats[1].base_stat);
            let poke2atk = parseInt(selectedPokemon2.stats[1].base_stat);
            let poke1spatk = parseInt(selectedPokemon1.stats[3].base_stat);
            let poke2spatk = parseInt(selectedPokemon1.stats[3].base_stat);
            let poke1def = parseInt(selectedPokemon1.stats[2].base_stat);
            let poke2def = parseInt(selectedPokemon1.stats[2].base_stat);
            let poke1spdef = parseInt(selectedPokemon1.stats[4].base_stat);
            let poke2spdef = parseInt(selectedPokemon1.stats[4].base_stat);

            console.log(poke2Relations)
            console.log(poke1Relations)
            let countDoubleTo = 0;
            let countHalfTo = 0;
            //console.log(poke1atk)
            //console.log(poke2atk)
            let poke1stats = 0;
            let poke2stats = 0;
            console.log(selectedPokemon1)
            console.log(selectedPokemon2)
            for(let i = 0; i<selectedPokemon1.stats.length;i++)
            {
                    poke1stats += parseInt(selectedPokemon1.stats[i].base_stat)
            }
            for(let i = 0; i<selectedPokemon2.stats.length;i++)
            {
                poke2stats += parseInt(selectedPokemon2.stats[i].base_stat)

            }
            console.log(poke1stats)
            console.log(poke2stats)
            poke1stats = poke1stats - poke1atk;
            poke2stats = poke2stats - poke2atk;
            poke1stats = poke1stats - poke1spatk;
            poke2stats = poke2stats - poke2spatk;
            poke2stats = poke2stats - poke2def;
            poke1stats = poke1stats - poke1def;
            poke2stats = poke2stats - poke2spdef;
            poke1stats = poke1stats - poke1spdef;
            poke1stats += parseInt(selectedPokemon1.base_experience)
            poke2stats += parseInt(selectedPokemon2.base_experience)
            if(selectedPokemon1.weight > 3000)
            {
                poke1stats += parseInt(selectedPokemon1.weight) /3

            }
            else
            {
                poke1stats += parseInt(selectedPokemon1.weight)

            }
            if(selectedPokemon2.weight >3000)
            {
                poke2stats += parseInt(selectedPokemon2.weight)/3
            }
            else{
                poke2stats += parseInt(selectedPokemon2.weight)
            }


            for(let i = 0; i< poke1Relations.length;i++)//pro prvniho pokemona
            {
                //poke1Relations[i]
               // console.log(poke1Relations[i].damage_relations)

                for(var a in poke1Relations[i].damage_relations.double_damage_to)
                {
                 //console.log(poke1Relations[i].damage_relations.double_damage_to[a].name)
                    for(let c = 0; c<poke2Relations.length;c++) {
                        if (poke2Relations[c].type === poke1Relations[i].damage_relations.double_damage_to[a].name && countDoubleTo === 0)
                        {
                            poke1spatk = poke1spatk *3;
                            poke1atk = poke1atk * 1.7;
                            countDoubleTo ++;
                             poke1stats = poke1stats * 1.1
                        }
                    }

                }
                for(var a in poke1Relations[i].damage_relations.half_damage_to)
                {
                    //console.log(poke1Relations[i].damage_relations.half_damage_to[a].name)
                    for(let c = 0; c<poke2Relations.length;c++) {
                        if (poke2Relations[c].type === poke1Relations[i].damage_relations.half_damage_to[a].name && countHalfTo === 0)
                        {
                            poke1atk = poke1atk /1.5;
                            poke1spatk = poke1spatk / 1.1;
                            poke1spdef = 60
                            poke1def = 40
                            countHalfTo ++;
                        }
                    }

                }
            }
            countDoubleTo = 0;
            countHalfTo = 0;
            for(let i = 0; i< poke2Relations.length;i++)//pro drureho pokemona
            {


                for(var a in poke2Relations[i].damage_relations.double_damage_to)
                {
                    //console.log(poke2Relations[i].damage_relations.double_damage_to[a].name)
                    for(let c = 0; c<poke1Relations.length;c++) {
                        if (poke1Relations[c].type === poke2Relations[i].damage_relations.double_damage_to[a].name && countDoubleTo === 0)
                        {
                            poke2atk = poke2atk * 1.7;
                            poke2spatk = poke2spatk * 3
                            poke2stats = poke2stats * 1.1
                            countDoubleTo ++;
                        }
                    }

                }
                for(var a in poke2Relations[i].damage_relations.half_damage_to)
                {
                    //console.log(poke2Relations[i].damage_relations.half_damage_to[a].name)
                    for(let c = 0; c<poke1Relations.length;c++) {
                        if (poke1Relations[c].type === poke2Relations[i].damage_relations.half_damage_to[a].name && countHalfTo === 0)
                        {

                            poke2atk = poke2atk / 1.5;
                            poke2spatk = poke2spatk /1.1;
                            poke2spdef = 60
                            poke2def = 40
                            countHalfTo ++;


                        }
                    }

                }
            }
            console.log(poke1stats)
            console.log(poke2stats)
            let count = 0;
            for(let i = 0; i<selectedPokemon1.types.length;i++)
            {
                if(selectedPokemon1.types[i].type.name == "psychic" && parseInt(selectedPokemon1.weight) > 100)
                {

                    poke1stats = poke1stats * 1.3


                }
                if(count === 0)
                {
                    if(selectedPokemon1.name === "mewtwo" || selectedPokemon1.name === "mewtwo-mega-x" || selectedPokemon1.name === "mewtwo-mega-y") {

                        poke1stats = poke1stats * 2;
                        count++;
                        //console.log(poke1stats)

                    }
                    else if (selectedPokemon1.name == "mew")
                    {
                        poke1stats = poke1stats * 5;
                    }
                }

                if(selectedPokemon1.types[i].type.name == "steel")
                {
                    poke1stats = poke1stats * 1.2222222222;

                }
            }

            if(selectedPokemon1.name.slice(-2) == "-y" || selectedPokemon1.name.slice(-2) == "-x" && selectedPokemon1.name === "mewtwo-mega-x" && selectedPokemon1.name === "mewtwo-mega-y")
            {
                poke1stats = poke1stats * 1.7
            }
            if(selectedPokemon2.name.slice(-2) == "-y" || selectedPokemon2.name.slice(-2) == "-x" && selectedPokemon2.name === "mewtwo-mega-x" && selectedPokemon2.name === "mewtwo-mega-y")
            {
                poke2stats = poke2stats * 1.7
            }
            count = 0;
            for(let i = 0; i<selectedPokemon2.types.length;i++)
            {
                if(selectedPokemon2.types[i].type.name == "psychic" && parseInt(selectedPokemon2.weight) > 100)
                {
                    poke2stats = poke2stats * 1.3
                }
                if(count === 0) {
                    if (selectedPokemon2.name === "mewtwo" || selectedPokemon2.name === "mewtwo-mega-x" || selectedPokemon2.name === "mewtwo-mega-y") {

                        poke2stats = poke2stats * 2;
                        count++;

                    }
                    else if(selectedPokemon2.name == "mew")
                    {
                        poke2stats = poke2stats * 5
                    }
                }

                if(selectedPokemon2.types[i].type.name == "steel")
                {
                    poke2stats = poke2stats * 1.2222222222;
                }
            }

            if(selectedPokemon1.name == "ditto" && selectedPokemon2.name != "ditto" && selectedPokemon2.name != "mew" && selectedPokemon2.name != "mewtwo"&&selectedPokemon2.name != "mewtwo-mega-y" && selectedPokemon2.name != "mewtwo-mega-x")
            {
                poke1stats = poke2stats * 2;
            }
            if(selectedPokemon1.name != "ditto" && selectedPokemon2.name == "ditto" && selectedPokemon1.name != "mewtwo" && selectedPokemon1.name != "mewtwo" &&selectedPokemon1.name != "mewtwo-mega-y" && selectedPokemon1.name != "mewtwo-mega-x")
            {
                poke2stats = poke1stats * 2;
            }
            //console.log(poke1atk)
            //console.log(poke2atk)
            poke2stats += poke2atk;
            poke1stats += poke1atk;
            poke1stats += poke1spatk + poke1def + poke1spdef;
            poke2stats += poke2spatk + poke2def + poke2spdef;
            console.log(poke1stats)
            console.log(poke2stats)
            if(selectedPokemon1.name === "mewtwo-mega-y" && selectedPokemon2.name === "mewtwo-mega-x")
            {
                poke1stats = poke2stats
            }
            else if(selectedPokemon1.name ==="mewtwo-mega-x" && selectedPokemon2.name === "mewtwo-mega-y")
            {
                poke1stats = poke2stats
            }
            let poke1proc = 0;
            let fin = 0;

            let procent = 0;
            if(poke1stats === poke2stats)
            {
                fin = 50;
            }
            else if(poke1stats > poke2stats)
            {
                poke1proc =poke1stats - poke2stats * 1.5
                if(poke1proc < 0)
                {
                    poke1proc = poke1proc*-1;

                }
                procent =  (poke1stats + poke2stats -poke1proc) / 100;
                fin = (poke2stats-poke1proc)/procent
            }
            else if(poke2stats > poke1stats){
                poke1proc = poke2stats - poke1stats
                if(poke1proc < 0)
                {
                    poke1proc = poke1proc*-1;

                }
                procent =  (poke1stats + poke2stats -poke1proc) / 100;

                fin = (poke1stats-poke1proc)/procent;
            }

            if(poke1stats < poke2stats )
            {

            }
            else
            {
                //console.log(fin);
                fin = 100 - fin;
            }
            if(fin > 100) fin = 100
            if(fin <0) fin = 0;
            //console.log(poke1proc)
            //console.log(fin)
            fin =  Math.round(fin)
            setWinChnace(fin)
            }, [selectedPokemonDmg1, selectedPokemonDgm2]);
        const Poke1 = () => {
            if(winChnace >=0)
            {
                return (
                        <div className={"flex justify-center justify-evenly mt-6"}>
                            <PokemonBattleCard name={selectedPokemon1.name} src={selectedPokemon1.sprites.front_default} abilitis={selectedPokemon1.abilities} winChance={winChnace} types={selectedPokemon1.types} />
                            <PokemonBattleCard name={selectedPokemon2.name} src={selectedPokemon2.sprites.front_default} abilitis={selectedPokemon2.abilities} winChance={100 - winChnace} types={selectedPokemon2.types}/>
                        </div>
                )
            }
        }

        const {handleSubmit, control} = useForm();

        return (
            <div>
                <div>
                    <Navbar curTeam={null} toggleTeam={null} currpage={"singlepokemonWinchance"} />

                    <div className="max-w-xl mx-auto mt-10 p-4 bg-white rounded shadow relative">
                        <h1 className="text-2xl font-semibold mb-4 text-center">Winrate calculator</h1>
                        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                            <Controller
                                name="pokemon1"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        options={names}
                                        placeholder="Vyber prvního Pokémona"
                                    />
                                )}
                            />
                            <Controller
                                name="pokemon2"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        options={names}
                                        placeholder="Vyber druhého Pokémona"
                                    />
                                )}
                            />
                            <button
                                type="submit"
                                className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
                            >
                                Zobrazit Pokémona
                            </button>
                        </form>
                        <Poke1 ></Poke1>
                    </div>

                </div>
            </div>
        );
    };

    export default WinRatecalculator;